export const CHANGE_PASSWORD_INFO_TEXT = [
  '8자~16자, 영문/숫자/특수문자 3가지 이상 조합으로 입력해 주세요.',
  '3자 이상 연속되거나 동일한 문자 숫자는 사용이 불가합니다.\n(ex: aaa, 111, abc, 123)',
  '키보드에서 연속된 문자는 사용이 불가합니다. (ex: qwe, asd)',
  '이전과 동일한 비밀번호 사용이 불가합니다.',
  '이메일과 동일한 비밀번호 사용이 불가합니다.',
];

export const FIND_PASSWORD_INFO_TEXT = [
  '시스템에 등록된 아이디와 이메일 주소를 입력해주세요.',
  '일치하는 정보가 있을 경우, 해당 이메일로 임시 비밀번호와 재설정 링크가 전송됩니다.',
  '비밀번호 재설정 링크를 통해 재설정 후 다시 로그인 해 주세요.',
  '일치하는 정보를 찾을 수 없는 경우, 컬리 담당자에게 별도 연락 부탁드립니다.',
];

export const FIND_ID_INFO_TEXT = [
  '시스템에 등록된 (화주사)담당자명과 이메일주소를 입력해주세요.',
  '일치하는 정보가 있을 경우, 해당 이메일로 아이디 정보가 전송됩니다.',
  '일치하는 정보를 찾을 수 없는 경우, 컬리 담당자에게 별도 연락 부탁드립니다.',
];
